module.exports = __webpack_public_path__ + "img/maurice-mulder.cd36e134.png";